// extracted by mini-css-extract-plugin
module.exports = {"QuizCreator":"_2r9TeYtohsu2lCF8M4U1c6"};